module.exports = __webpack_public_path__ + "img/品質管理3-12.4f9512f6.png";